import CollectionFormPresenter from "../../../collection-form/CollectionFormPresenter";
import BaseFormPage from "../../../../base/BaseFormPage";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import NavBar from "../../../../components/navigation";
import FormFactory from "../../../../components/FormFactory";
import withRouter from "../../../../withRouter";
import AddTask from "./add-task/AddTask";

class WorkFlowFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      taskObj: {},
      advanced: false,
      tasks: [],
      isTaskOpen: false,
      name: "",
      description: "",
      isTaskEmpty: false,
    };
    this.presenter = new CollectionFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.object !== this.state.object) {
      this.setState({ tasks: this.state.object.tasks || [] });
    }
  }

  getCollectionName() {
    return "work_flows";
  }

  onClickAdvance() {
    this.setState((prevState) => ({ advanced: !prevState.advanced }));
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  handleAddTask() {
    this.setState({ isTaskOpen: true, taskObj: {}, isTaskEmpty: false });
  }

  closeTaskForm = (value) => {
    this.setState({ isTaskOpen: value, taskObj: {} });
  };

  async handleAddBTN() {
    if (this.state.tasks.length === 0) {
      this.setState({ isTaskEmpty: true });
      return;
    }
    const { requestType, ...rest } = this.state.object;
    const data = {
      ...rest,
      requestType: { id: requestType.id },
      tasks: Object.values(this.state.tasks),
    };

    await upsertUseCase().execute("work_flows", data);
    this.showSuccess("Success");
    this.navigateBack();
  }

  addTaskData = (data) => {
    this.setState((prevState) => {
      const tasks = [...prevState.tasks];
      if (
        data.index !== null &&
        data.index !== undefined &&
        data.index !== ""
      ) {
        tasks[data.index] = data; // Update existing task
      } else {
        data.index = tasks.length;
        console.log("first: ", data);
        tasks.push(data); // Add new task
      }
      return {
        tasks,
        isTaskOpen: false,
        taskObj: {},
      };
    });
  };

  handleTaskDelete = (index) => {
    this.setState((prevState) => {
      const tasks = [...prevState.tasks];
      tasks.splice(index, 1);
      return { tasks };
    });
  };

  handleTaskEdit = (item, index) => {
    this.setState({ isTaskOpen: true, taskObj: { ...item, index } });
  };

  moveTaskUp = (index) => {
    if (index > 0) {
      const tasks = [...this.state.tasks]; // Copy tasks array
      const task = tasks[index]; // Get the current task
      const taskAbove = tasks[index - 1]; // Get the task above

      // Swap the tasks
      tasks[index] = taskAbove;
      tasks[index - 1] = task;

      // Update their indices
      tasks[index].index = index;
      tasks[index - 1].index = index - 1;

      this.setState({ tasks }); // Update the state with the reordered tasks
    }
  };

  moveTaskDown = (index) => {
    if (index < this.state.tasks.length - 1) {
      const tasks = [...this.state.tasks]; // Copy tasks array
      const task = tasks[index]; // Get the current task
      const taskBelow = tasks[index + 1]; // Get the task below

      // Swap the tasks
      tasks[index] = taskBelow;
      tasks[index + 1] = task;

      // Update their indices
      tasks[index].index = index;
      tasks[index + 1].index = index + 1;

      this.setState({ tasks }); // Update the state with the reordered tasks
    }
  };

  render() {
    const { object, tasks, isTaskOpen, isTaskEmpty, taskObj } = this.state;
    console.log("TAS: ", tasks);
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>No schema</h1>;
    const label = this.getObjectId() === undefined ? "Add " : "Update ";
    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <h1 className="fw-bold mt-2 mb-4 text-capitalize">
                  {(schema.label || this.getCollectionName()) + " Details"}
                </h1>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.handleAddBTN();
                  }}
                >
                  <div className="row d-flex align-items-center justify-content-center gap-4">
                    <div className="col-lg-4 border p-4">
                      <FormFactory
                        className="pb-5"
                        schema={schema}
                        object={object}
                        onChange={this.onChangeObject.bind(this)}
                        excludeFields={["tasks"]}
                      />
                    </div>
                    <div className="col-lg-7 border">
                      <header className="p-4 border-bottom d-flex justify-content-between align-items-center">
                        <span className="fw-bold">Tasks</span>
                        <button
                          className="btn btn-primary"
                          type="button"
                          onClick={this.handleAddTask.bind(this)}
                        >
                          <i className="bi bi-plus-lg" />
                        </button>
                      </header>

                      {tasks.length > 0 ? (
                        <div className="d-grid p-3">
                          {tasks.map((item, index) => (
                            <div className="d-flex" key={index}>
                              <div
                                className="circle bg-primary text-white d-flex align-items-center justify-content-center rounded-circle mt-3"
                                style={{ width: "20px", height: "20px" }}
                              >
                                <i className="bi bi-circle-fill" />
                              </div>
                              <div className="d-flex flex-grow-1 border-bottom p-3 row">
                                <div className="d-grid col-lg-9">
                                  <span className="fw-bold">{item.name}</span>
                                  <p>{item.description}</p>
                                </div>
                                <div className="d-flex flex-grow-1 justify-content-end align-items-end gap-1 col-lg-3">
                                  <button
                                    className="btn btn-primary"
                                    style={{ padding: "3px 6px" }}
                                    type="button"
                                    onClick={() =>
                                      this.handleTaskEdit(item, index)
                                    }
                                  >
                                    <i className="bi bi-pencil-square" />
                                  </button>
                                  <button
                                    className="btn btn-primary"
                                    style={{ padding: "3px 6px" }}
                                    type="button"
                                    onClick={() => this.handleTaskDelete(index)}
                                  >
                                    <i className="bi bi-trash" />
                                  </button>
                                  <button
                                    className="btn btn-primary"
                                    style={{ padding: "3px 6px" }}
                                    type="button"
                                    onClick={() => this.moveTaskUp(index)}
                                  >
                                    <i className="bi bi-chevron-up" />
                                  </button>
                                  <button
                                    className="btn btn-primary"
                                    style={{ padding: "3px 6px" }}
                                    type="button"
                                    onClick={() => this.moveTaskDown(index)}
                                  >
                                    <i className="bi bi-chevron-down" />
                                  </button>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="d-flex align-items-center justify-content-center">
                          <div className="d-grid p-4">
                            <img
                              width="120"
                              src={"/noData.svg"}
                              alt="No Data"
                            />
                            <button
                              type="button"
                              className="btn btn-light border-primary"
                              onClick={this.handleAddTask.bind(this)}
                            >
                              Add Tasks
                            </button>
                          </div>
                        </div>
                      )}

                      {isTaskEmpty && (
                        <p className="text-danger">
                          Please add at least 1 task.
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary fs-sm me-3"
                    >
                      <i className="bi bi-file-earmark-check me-2"></i>
                      {label}
                    </button>
                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
                {isTaskOpen && (
                  <AddTask
                    // key={taskObj.index || "new"}
                    isTaskOpen={() => this.setState({ isTaskOpen: false })}
                    addTaskData={this.addTaskData}
                    taskObj={taskObj}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(WorkFlowFormPage);
